
export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fd61aaf526c50388c65d4796fe76c75a.jpg"
          alt="골프장 배경"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full pt-16 md:pt-20">
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
          대한민국 골퍼 500만의<br />
          선택 NO.1<br />
          스마트스코어 멤버십
        </h1>

        <p className="text-sm sm:text-base md:text-xl text-white/90 mb-4 md:mb-8 max-w-3xl mx-auto leading-relaxed">
          장기적이고 안정적인 서비스<br />
          중소기업 기업부 예비 유니콘 선정
        </p>

        <p className="text-xs sm:text-sm md:text-lg text-white/80 mb-6 md:mb-10 px-2">
          NH투자증권 PE · 산업은행 · 현대자동차 · VIG파트너스 검증된 투자자 참여
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center mb-8 md:mb-16">
          <a
            href="#pricing"
            className="w-full sm:w-auto bg-blue-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-blue-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            멤버십 알아보기
          </a>
          <a
            href="#signup"
            className="w-full sm:w-auto bg-white/10 backdrop-blur-sm text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            상담 신청하기
          </a>
        </div>

        <div className="grid grid-cols-3 gap-3 md:gap-6 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/20">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1">420+</div>
            <div className="text-white/80 text-xs md:text-sm">제휴 골프장</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/20">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1">100%</div>
            <div className="text-white/80 text-xs md:text-sm">입회비 반환</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/20">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1">5년</div>
            <div className="text-white/80 text-xs md:text-sm">연회비 면제</div>
          </div>
        </div>
      </div>
    </section>
  );
}
